export var KubitNavigationRowVariantType;
(function (KubitNavigationRowVariantType) {
    /**
     * @deprecated Use REGULAR variant instead
     */
    KubitNavigationRowVariantType["REGULAR_ALT"] = "REGULAR_ALT";
    KubitNavigationRowVariantType["REGULAR"] = "REGULAR";
})(KubitNavigationRowVariantType || (KubitNavigationRowVariantType = {}));
export var KubitNavigationRowSizeType;
(function (KubitNavigationRowSizeType) {
    KubitNavigationRowSizeType["SMALL"] = "SMALL";
})(KubitNavigationRowSizeType || (KubitNavigationRowSizeType = {}));
//# sourceMappingURL=variants.js.map